<fieldset [disabled]="isLoading$().show">
  <ng-container
    *ngIf="!!stateSignal$().workflow?.profile?.appProfile?.jobDescription"
  >
    <postgenie-profile (profileEvent)="save($event)"></postgenie-profile>
  </ng-container>
  <ng-container
    *ngIf="!stateSignal$().workflow?.profile?.appProfile?.jobDescription"
  >
    <postgenie-new-profile
      [user]="user"
      (profileEvent)="save($event)"
    ></postgenie-new-profile>
  </ng-container>
</fieldset>
